import css from '@styled-system/css';
import { systemPropsFns } from '../../system/styled-system.es.js';
import styled from 'styled-components';

const nbOfLines = ({ nbOfLines: nbOfLines2 }) => {
  if (typeof nbOfLines2 !== "number") {
    return {};
  }
  return {
    display: "-webkit-box",
    WebkitLineClamp: nbOfLines2 || "unset",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    wordBreak: "break-word"
  };
};
const sx = (props) => css(props.sx)(props.theme);
const COMMON_PROPS = ["kind", "variant", "shape", "size"];
const Box = styled("div").withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => !COMMON_PROPS.includes(prop) && defaultValidatorFn(prop)
})`
    && {
        ${nbOfLines};
        ${sx};
        ${systemPropsFns};
    }
`;
Box.displayName = "Box";

export { Box };
//# sourceMappingURL=Box.es.js.map
